<div class="grid more-info" *ngrxLet="{ link: link$, linkText: linkText$, isDownload: isDownload$, route: route$ } as vm">
    <h3 *ngIf="headerText$ | ngrxPush as headerText">{{ headerText }}</h3>
    <ng-content></ng-content>
    <div *ngIf="vm.linkText">
        <a [href]="vm.link" class="button-secondary" *ngIf="vm.link" [attr.download]="vm.isDownload ? vm.link : undefined" target="_blank">
            {{ vm.linkText }}
            <dtm-ui-icon name="download" *ngIf="vm.isDownload" />
        </a>
        <a [routerLink]="vm.route" class="button-secondary" *ngIf="vm.route"> {{ vm.linkText }}</a>
    </div>
</div>
